module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAUBJREFUOE+tk89KAlEUxr/vqlmvEELjbFoatGgxQeCuF+gNGqUosheZUiybFu17gXZGpESLona10QmkB2hTjXVPzKAwTaYwdXfnnnN+nO/8IWKvkb8u9PlhC1AEYAzcHoFmRtJuubt0H03h0DgxzqdfVNaBiE1CxcGBLQIN0vX83q7TW3sN/kJAJXc6Y2ZyZ0JZGZUY/6PwotPvrQaQELBnthoKLMUDtztW6K+abYn7NORop7NcZjV/WQBSt6D8KHscAEKdEllkzbyqC/TGqNLHAkL96oD7ZuuB4HwSgEAeWTPbbwJkkwAIvP8dME7CpJEOJPzexEkAaByybrQXPsmbxGNMukgUuFtdq/Q/qzy8h7mpWUeJWh8lJ+yHUGvq4yf/ufLtmKLNCnriQ2ylUFRgeM4a4kGzmQbcTc+6i8Z/AXYWqQWPQrjQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tipP.png
// module id = 35
// module chunks = 0